<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-file-powerpoint"
      texto-titulo="Nuevo pedido"
    ></TituloComponent>
    <div class="card-outline-primary mb-3 card">
      <div class="card-header">
        <i class="fas fa-user header-icon icon-gradient bg-alternate"></i>Datos de cliente
      </div>
      <div class="card-body p-0">
        <div class="grid-menu grid-menu-2col" v-if="!cliente.id">
          <div class="no-gutters row">
            <div class="col-12">
              <button
                class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary opacity-7"
                @click="modalCliente = true"
              >
                <i class="fas fa-user-check btn-icon-wrapper btn-icon-lg mb-3"></i
                >Seleccionar cliente
              </button>
            </div>
          </div>
        </div>
        <div class="widget-content hoverable" v-else @click="modalCliente = true">
          <div class="widget-content-wrapper row">
            <div class="widget-content-left col-12">
              <h5 class="widget-heading text-success">{{ cliente.nombre }}</h5>
              <div class="widget-subheading opacity-10 row">
                <span class="col-sm-auto col-12 text-alternate">
                  N° Doc/CUIL:
                  <b>{{ cliente.numero_documento | cuil }}</b>
                </span>
                <span class="col-sm-auto col-12">
                  IVA:
                  <b>{{ cliente.responsabilidad_iva.descripcion }}</b>
                </span>
                <span class="col-sm-auto col-12">
                  Domicilio:
                  <b>{{ cliente.domicilio }}</b>
                </span>
                <span class="col-sm-auto col-12">
                  Localidad:
                  <b>{{ cliente.localidad }}</b>
                </span>
                <span class="col-sm-auto col-12">
                  Saldo anterior:
                  <b>${{ cliente.saldo | numFormat("0,0.00") }}</b>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalSelectCliente
      v-if="modalCliente"
      @selectCliente="onSelectCliente"
      @cerrarModalCliente="modalCliente = false"
    ></ModalSelectCliente>
    <div class="card mb-3">
      <div class="card-body">
        <div class="row">
          <div class="widget-wrapper col-lg-4">
            <div class="widget-heading opacity-10">
              <float-label label="Forma de pago" clase="w-100 mb-md-0">
                <select
                  name="forma_pago"
                  id="forma_pago"
                  class="form-control"
                  v-model="forma_pago"
                >
                  <option :value="null">Seleccione forma de pago</option>
                  <option value="Contado">Contado</option>
                  <option value="Cuenta corriente">Cuenta corriente</option>
                </select>
              </float-label>
            </div>
          </div>
          <div class="widget-wrapper col-lg-4">
            <div class="widget-heading opacity-10">
              <float-label label="Facturar día:" clase="w-100 mb-md-0">
                <input
                  type="date"
                  id="facturar_dia"
                  class="form-control"
                  v-model="dia_facturacion"
                />
              </float-label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-outline-primary mb-3 card">
      <div class="card-header">
        <i class="fas fa-filepowerpoint header-icon icon-gradient bg-success"></i>Detalle
        del pedido
      </div>
      <div class="card-body p-0">
        <ul class="list-group list-group-flush mb-3" v-if="detalles.length > 0">
          <li
            class="list-group-item hoverable"
            v-for="(detalle, i) in detalles"
            :key="i"
            @click="clickDetalle(detalle, i)"
          >
            <div class="widget-content p-0">
              <div class="widget-content-wrapper row">
                <div class="widget-content-left col-sm-9 col-12">
                  <h4 class="widget-heading text-primary opacity-10">
                    {{ detalle.descripcion }}
                  </h4>
                  <div class="widget-subheading opacity-10 row">
                    <h5 class="col-sm-auto col-6">
                      Precio:
                      <b class="text-success"
                        >${{ detalle.importe | numFormat("0,0.00") }}</b
                      >
                    </h5>
                    <h5 class="col-sm-auto col-6">
                      Descuento:
                      <b class="text-focus">{{ detalle.descuento }}%</b>
                    </h5>
                    <h5 class="col-sm-auto col-6">
                      Cantidad:
                      <b class="text-alternate">{{ detalle.cantidad }}</b>
                    </h5>
                  </div>
                </div>
                <div class="widget-content-right col-sm-3 text-right">
                  <div class="widget-numbers text-danger">
                    <span class="count-up-wrapper"
                      >${{ detalle.total | numFormat("0,0.00") }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="grid-menu grid-menu-2col" v-if="detalles.length <= 25">
          <div class="no-gutters row">
            <div class="col-12">
              <button
                class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary opacity-7"
                @click="modalArticulo = true"
              >
                <i class="fas fa-plus btn-icon-wrapper btn-icon-lg mb-3"></i>Añadir
                detalle
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalSelectArticulo
      ref="selectArticulo"
      v-if="modalArticulo"
      @selectArticulo="onSelectArticulo"
      @cerrarModalArticulo="modalArticulo = false"
    ></ModalSelectArticulo>

    <div class="mb-3 card">
      <div class="no-gutters row">
        <div class="col-sm-12 col-md-4 col-xl-4 offset-md-8 offset-xl-8">
          <div
            class="card no-shadow rm-border bg-transparent widget-chart text-md-right text-center mr-md-3"
          >
            <div class="widget-chart-content">
              <div class="widget-numbers">
                Total:
                <span class="text-success">${{ total | numFormat("0,0.00") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <EditarDetalle
        v-if="editDetalle"
        :detalle="detalleSeleccionado"
        @confirmDetalle="onConfirmDetalle"
        @cerrarEditarDetalle="editDetalle = false"
      ></EditarDetalle>
      <div class="text-center d-block p-3 card-footer">
        <button
          class="btn-pill btn-shadow btn-wide fsize-1 btn btn-primary btn-lg"
          @click.prevent="guardar"
        >
          <span class="mr-1">Guardar pedido</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import Cliente from "@/models/cliente";
import Articulo from "@/models/articulo";
import ModalSelectCliente from "@/components/views/clientes/ModalSelectCliente";
import ModalSelectArticulo from "@/components/views/articulos/ModalSelectArticulo";
import BlockUI from "@/components/loaders/BlockUI";
import FloatLabel from "@/components/layouts/FloatLabel";
import Swal from "sweetalert2";
import axios from "axios";
import EditarDetalle from "@/components/views/comprobantes/EditarDetalle";
import moment from "moment";
export default {
  name: "NuevoPedido",
  components: {
    TituloComponent,
    BlockUI,
    FloatLabel,
    ModalSelectCliente,
    ModalSelectArticulo,
    EditarDetalle,
  },
  data() {
    return {
      cliente: new Cliente(null, "", "", null, "", null),
      modalCliente: false,
      articulo: new Articulo(null, "", null, null, null, null, null, null, 5),
      modalArticulo: false,
      forma_pago: null,
      lista_id: null,
      lista: null,
      dia_facturacion: null,
      listas: [],
      detalles: [],
      total: 0,
      indexDetalle: null,
      detalleSeleccionado: {},
      editDetalle: false,
      loading: false,
    };
  },
  watch: {
    lista_id: function () {
      if (this.lista_id || this.lista_id != undefined || this.lista_id != null) {
        this.lista = [...this.listas].filter((lista) => lista.id == this.lista_id)[0];
      } else {
        this.lista = null;
      }
      this.cambiarImportes();
    },
  },
  mounted: function () {
    window.onbeforeunload = () => {
      "Estás seguro que deseas salir?";
    };
    this.getListas();
    let date = moment().add(1, "days").format("Y-MM-DD");
    this.dia_facturacion = date;
  },
  methods: {
    onSelectCliente(cliente) {
      this.cliente = cliente;
      this.modalCliente = false;
      if (this.cliente.id != null) {
        this.lista_id = this.cliente.lista_id;
      }
      this.cambiarImportes();
    },
    async onSelectArticulo(articulo) {
      const { value: cantidad } = await Swal.fire({
        title: `Cantidad de ${articulo.descripcion}`,
        allowOutsideClick: false,
        input: "text",
        inputPlaceholder: "0",
        inputAttributes: {
          maxlength: 10,
          inputmode: "numeric",
        },
        showCancelButton: true,
        confirmButtonText: "Agregar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        preConfirm: (cantidad) => {
          if (isNaN(cantidad)) {
            Swal.showValidationMessage(`Sólo se aceptan números.`);
            return false;
          }
          if (articulo.stock < cantidad) {
            Swal.showValidationMessage(
              `Stock insuficiente, quedan ${articulo.stock} unidades.`
            );
            return false;
          }
          this.$refs.selectArticulo.clear();
          return cantidad;
        },
      });
      if (this.detalles.length >= 40) {
        Swal.fire({
          icon: "warning",
          title: "Listo!",
          text: `Has llegado a la cantidad máxima de items`,
        });
        this.modalArticulo = false;
      }
      if (cantidad) {
        let detalle = {};
        if (this.lista) {
          detalle.importe =
            articulo.precio_final + articulo.precio_final * (this.lista.porcentaje / 100);
        } else {
          detalle.importe = articulo.precio_final;
        }
        detalle.descripcion = `${articulo.descripcion}`;
        detalle.articulo = articulo;
        detalle.cantidad = cantidad;
        detalle.descuento = 0;
        detalle.total =
          detalle.cantidad * detalle.importe * (1 - detalle.descuento / 100);
        this.detalles.push(detalle);
        this.total += detalle.total;
      }
    },
    guardar() {
      if (this.cliente.id == null) {
        Swal.fire("Oops!", "Debe seleccionar un cliente", "warning");
        return false;
      }
      if (this.detalles.length == 0) {
        Swal.fire("Oops!", "Debe añadir detalles al pedido", "warning");
        return false;
      }
      if (!this.forma_pago) {
        Swal.fire("Oops!", "Debe seleccionar la forma de pago", "warning");
        return false;
      }
      if (!this.lista) {
        Swal.fire("Oops!", "Debe seleccionar la lista", "warning");
        return false;
      }
      this.loading = true;
      let pedido = {
        cliente: this.cliente.id,
        total: this.total,
        user_id: this.$store.state.auth.user.id,
        forma_pago: this.forma_pago,
        detalles: this.detalles,
        lista_id: this.lista_id,
        dia_facturacion: this.dia_facturacion,
      };
      axios
        .post("/pedidos", pedido)
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Éxito",
            text: `El pedido se guardó con éxito.`,
          });
          this.reset();
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            html: `<p>No se ha podido completar la operación.</p><p>${error.response?.data?.message ||
            error.response?.data?.error ||
            error?.message ||
            error}</p>`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cambiarImportes() {
      this.total = 0;
      for (let detalle of this.detalles) {
        if (this.lista && !detalle.editado) {
          detalle.importe =
            detalle.articulo.precio_final +
            detalle.articulo.precio_final * (this.lista.porcentaje / 100);
        }
        detalle.total = parseFloat(
          (detalle.cantidad * detalle.importe * (1 - detalle.descuento / 100)).toFixed(2)
        );
        this.total += detalle.total;
      }
    },
    getListas() {
      this.loading = true;
      axios.get("/listas").then((res) => {
        for (let lista of res.data.data) {
          this.listas.push(lista);
        }
        if (this.cliente.id != null) {
          this.lista_id = this.cliente.lista_id;
        } else {
          this.lista_id = 1;
        }
        this.loading = false;
      });
    },
    clickDetalle(detalle, index) {
      Swal.fire({
        title: detalle.articulo.descripcion,
        text: "¿Desea editar o eliminar?",
        showCancelButton: true,
        confirmButtonText: "Editar",
        cancelButtonText: "Eliminar",
        confirmButtonColor: "#f7b924",
        cancelButtonColor: "#d33",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.indexDetalle = index;
          this.detalleSeleccionado = { ...detalle };
          this.editDetalle = true;
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          this.detalles.splice(index, 1);
          this.cambiarImportes();
        }
      });
    },
    onConfirmDetalle(detalle) {
      this.detalles[this.indexDetalle] = { ...detalle };
      this.indexDetalle = null;
      this.editDetalle = false;
      this.detalleSeleccionado = {};
      this.cambiarImportes();
    },
    reset() {
      this.cliente = new Cliente(null, null, "", "", null, "", null);
      this.articulo = new Articulo(null, null, "", null, null, null, null, null, null, 5);
      this.forma_pago = null;
      this.lista_id = null;
      this.lista = null;
      this.dia_facturacion = null;
      this.listas = [];
      this.detalles = [];
      this.total = 0;
      this.indexDetalle = null;
      this.detalleSeleccionado = {};
      this.getListas();
      let date = new Date();
      date.setDate(date.getDate() + 1);
      this.dia_facturacion = date.toISOString().slice(0, 10);
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.cliente.id != null || this.detalles.length > 0) {
      Swal.fire({
        title: "Estás saliendo del pedido",
        text: "Si no se ha guardado se perderá la información, deseas salir?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Salir",
        cancelButtonText: "Quedarme",
      }).then((result) => {
        if (result.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
};
</script>
